import React from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import './RegenerateResponse.css';

const RegenerateResponse = ({ onRetry }) => {
    return (
        <div className="regenerate-response">
            <Message severity="error" text="Some error has occurred" />
            <Button
                label="Regenerate Response"
                icon="pi pi-refresh"
                className="retry-button p-button-danger"
                onClick={onRetry}
            />
        </div>
    );
};

export default RegenerateResponse;
